import { render, staticRenderFns } from "./NotasProyecto.vue?vue&type=template&id=2067c840"
import script from "./NotasProyecto.vue?vue&type=script&lang=js"
export * from "./NotasProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports